import { isString } from './isString'

export const isValidString = (str) => str.length > 0 && isString(str)
